import { render, staticRenderFns } from "./onlinebaseclassinfo.vue?vue&type=template&id=531470a8&scoped=true&"
import script from "./onlinebaseclassinfo.vue?vue&type=script&lang=js&"
export * from "./onlinebaseclassinfo.vue?vue&type=script&lang=js&"
import style0 from "./onlinebaseclassinfo.vue?vue&type=style&index=0&id=531470a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531470a8",
  null
  
)

export default component.exports